import React from 'react';
import { Box, Skeleton, Typography } from '@mui/material';
import { formatCurrency } from '../../qCockpit/components/SharedFrames';
import { shellTokens } from '../../shell/theme/shellTheme';

const pnlTone = (value) => {
    if (value > 0) return shellTokens.success;
    if (value < 0) return shellTokens.error;
    return shellTokens.text;
};

const KpiCard = ({ label, value, tone = shellTokens.text }) => (
    <Box
        sx={{
            bgcolor: shellTokens.surface,
            border: `1px solid ${shellTokens.border}`,
            borderRadius: `${shellTokens.innerRadius}px`,
            px: 1.75,
            py: 1.5,
            minWidth: 0,
        }}
    >
        <Typography
            sx={{
                fontSize: '0.62rem',
                fontWeight: 700,
                letterSpacing: '0.06em',
                textTransform: 'uppercase',
                color: shellTokens.muted,
            }}
        >
            {label}
        </Typography>
        <Typography
            sx={{
                fontSize: '1.15rem',
                fontWeight: 700,
                mt: 0.4,
                color: tone,
                fontFamily: shellTokens.monoFamily,
            }}
        >
            {value}
        </Typography>
    </Box>
);

const FleetKpiStrip = ({ summary, loading }) => {
    if (loading) {
        return (
            <Box
                sx={{
                    display: 'grid',
                    gridTemplateColumns: 'repeat(auto-fit, minmax(120px, 1fr))',
                    gap: 1.25,
                    mb: 1.75,
                }}
            >
                {Array.from({ length: 5 }).map((_, index) => (
                    <Skeleton
                        key={index}
                        variant="rounded"
                        height={72}
                        sx={{ borderRadius: `${shellTokens.innerRadius}px` }}
                    />
                ))}
            </Box>
        );
    }

    const safeSummary = summary || {};

    return (
        <Box
            sx={{
                display: 'grid',
                gridTemplateColumns: 'repeat(auto-fit, minmax(120px, 1fr))',
                gap: 1.25,
                mb: 1.75,
            }}
        >
            <KpiCard
                label="Fleet net"
                value={formatCurrency(safeSummary.netPnl ?? 0)}
                tone={pnlTone(safeSummary.netPnl ?? 0)}
            />
            <KpiCard label="Open positions" value={safeSummary.openPositions ?? 0} />
            <KpiCard label="Live instances" value={safeSummary.liveCount ?? 0} />
            <KpiCard
                label="Stale"
                value={safeSummary.staleCount ?? 0}
                tone={(safeSummary.staleCount ?? 0) > 0 ? shellTokens.warning : shellTokens.text}
            />
            <KpiCard
                label="Halted"
                value={safeSummary.haltedCount ?? 0}
                tone={(safeSummary.haltedCount ?? 0) > 0 ? shellTokens.error : shellTokens.text}
            />
        </Box>
    );
};

export default FleetKpiStrip;
